import { Icono } from './Icono';

const CANTIDAD_DE_TONOS = 5;

function iniciales(nombre: string): string {
  return nombre.split(' ').filter(Boolean).slice(0, 2).map((p) => p[0]).join('').toUpperCase();
}

// El tono sale de sumar los caracteres: la misma persona cae siempre en el mismo
// degradado y no hace falta guardarlo en ningún lado.
function tono(nombre: string): number {
  let suma = 0;
  for (const letra of nombre) suma += letra.charCodeAt(0);
  return (suma % CANTIDAD_DE_TONOS) + 1;
}

interface PropsAvatar {
  nombre: string;
  tamano?: number;
  anillo?: 'blanco' | 'coral' | 'ninguno';
  verificado?: boolean;
  /** Cuando el nombre ya está escrito al lado, el avatar no se vuelve a anunciar. */
  decorativo?: boolean;
}

export function Avatar({
  nombre, tamano = 40, anillo = 'blanco', verificado = false, decorativo = false,
}: PropsAvatar) {
  const accesible = decorativo
    ? { 'aria-hidden': true }
    : { role: 'img', 'aria-label': verificado ? `${nombre}, matrícula verificada` : nombre };

  return (
    <span className={`avatar avatar--${anillo}`} style={{ width: tamano, height: tamano }} {...accesible}>
      <span className={`avatar__cara avatar--tono-${tono(nombre)}`} style={{ fontSize: tamano * 0.36 }}>
        {iniciales(nombre)}
      </span>
      {verificado && (
        <span className="avatar__verificado" style={{ width: tamano * 0.32, height: tamano * 0.32 }}>
          <Icono nombre="check" tamano={tamano * 0.18} grosor={3} />
        </span>
      )}
    </span>
  );
}
